module.exports = __webpack_public_path__ + "img/bag.15532ad9.svg";